<template>
  <transition name="el-fade-in">
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
  </transition>
</template>

<script>
  export default {
    name: 'App',
    provide() {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isRouterAlive: true
      }
    },
    mounted() {
      document.onclick = function () {
        $(".menu").css({'visibility': 'hidden'});
      }
    },
    methods: {
      //测试推送
      reload() {
        this.isRouterAlive = false
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      }
    }
  }
</script>

<style>
  #app {
    position: fixed;
    width: 100%;
    height: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue